import { render, staticRenderFns } from "./StatementsCreation.vue?vue&type=template&id=364b5a39&"
import script from "./StatementsCreation.vue?vue&type=script&lang=js&"
export * from "./StatementsCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports